<template>
  <div class="page" :style="themeStyle">
    <div v-if="!loaded" class="loading">Loading</div>
    <div v-if="loaded" class="root">

      <!-- Top header strip -->
      <div class="cs-topstrip">
        <span class="ts-text">{{ loName }} & {{ realtorName }}</span>
        <span class="ts-dot">◆</span>
        <span class="ts-text">Mortgage Partnership</span>
      </div>

      <!-- Nav -->
      <nav class="cs-nav">
        <img v-if="loinfo && loinfo.main_logo" :src="loinfo.main_logo" class="cs-logo" />
    
      </nav>

      <!-- Hero banner with arch decoration -->
      <section class="cs-hero">
        <div class="hero-arch" aria-hidden="true"></div>
        <div class="cs-hero-content">
          <div class="ch-tag">
            <div class="tag-rule"></div>
            <span>Excellence in Lending</span>
            <div class="tag-rule"></div>
          </div>
          <h1 class="cs-h1" v-html="heroH1Html"></h1>
          <p class="cs-body">{{ heroBody }}</p>
          <div class="cs-btns">
            <a class="cs-btn-gold" :href="applyRightLink">{{ heroPrimaryText }}</a>
            <a v-if="applyLeftLink" class="cs-btn-ghost" :href="applyLeftLink">{{ heroSecondaryText }}</a>
          </div>
        </div>
      </section>

      <!-- Cards section on lighter background -->
      <section class="cs-agents">
        <div class="cs-agents-inner">

          <div class="cs-card lo-cs">
            <div class="cc-top lo-cc-top">
              <img v-if="loinfo && loinfo.lo_image" :src="loinfo.lo_image" class="cc-img" />
              <div class="cc-title-block">
                <span class="cc-tag">Loan Officer</span>
                <div class="cc-name">{{ loName }}</div>
                <div class="cc-role">{{ loTitle }}</div>
                <div v-if="loinfo && loinfo.nmls" class="cc-nmls">NMLS {{ (loinfo.nmls || "").trim() }}</div>
              </div>
            </div>
            <div class="cc-mid"></div>
            <div class="cc-contacts">
              <a v-if="loinfo && loinfo.phone_number" :href="'tel:' + loinfo.phone_number" class="cc-link lo-cc-link">{{ loinfo.phone_number }}</a>
              <a v-if="loinfo && loinfo.email" :href="'mailto:' + loinfo.email" class="cc-link lo-cc-link">{{ loinfo.email }}</a>
            </div>

          </div>

          <div class="cs-divider">
            <div class="cd-line"></div>
            <div class="cd-icon">✦</div>
            <div class="cd-line"></div>
          </div>

          <div class="cs-card re-cs">
            <div class="cc-top re-cc-top">
              <img v-if="realtor && realtor.headshot_url" :src="realtor.headshot_url" class="cc-img" />
              <div class="cc-title-block">
                <span class="cc-tag re-cc-tag">Partner</span>
                <div class="cc-name">{{ realtorName }}</div>
                <div class="cc-role">{{ realtor && realtor.brokerage_name }}</div>
              </div>
            </div>
            <div class="cc-mid re-mid"></div>
            <div class="cc-contacts">
              <a v-if="realtor && realtor.phone_number" :href="'tel:' + realtor.phone_number" class="cc-link re-cc-link">{{ realtor.phone_number }}</a>
              <a v-if="realtor && realtor.email" :href="'mailto:' + realtor.email" class="cc-link re-cc-link">{{ realtor.email }}</a>
              <a v-if="realtor && realtor.website_url" :href="realtor.website_url" class="cc-link re-cc-link" target="_blank" rel="noreferrer">Website →</a>
            </div>
          </div>

        </div>
      </section>

    </div>
  </div>
</template>

<script>
import coBrandMixin from "../../mixins/coBrandMixin.js";
const BRAND_COLORS = {
  zonalending: { primary: "#eb610a", accent: "#646363" },
  radiantmortgage: { primary: "#1C1F39", accent: "#DB9457" },
  conradmortgage: { primary: "#4a4b4b", accent: "#d4af37" },
  theimgteam: { primary: "#ff6633", accent: "#4a4c54" },
  responsivemortgage: { primary: "#07212c", accent: "#FF7F47" },
  kpmortgage: { primary: "#0D2821", accent: "#34BFC6" },
  ignitemortgage: { primary: "#000000", accent: "#00b1eb" },
  goldstarfinancial: { primary: "#0b1726", accent: "#c69c39" },
};
function getBrandKey(email) {
  if (!email) return null;
  return email.slice(email.indexOf("@") + 1).toLowerCase().split(".")[0] || null;
}
export default {
  name: "CoBrandCrimson",
  mixins: [coBrandMixin],
  computed: {
    brandKey() { const k = getBrandKey(this.loinfo?.email); return (k && BRAND_COLORS[k]) ? k : "goldstarfinancial"; },
    palette() { return BRAND_COLORS[this.brandKey] || BRAND_COLORS.goldstarfinancial; },
    themeStyle() { return { "--p": this.palette.primary, "--a": this.palette.accent }; },
    heroH1Html() {
      const h = (this.realtor?.header1 || this.loinfo?.header1 || "").trim();
      if (!h) return "Exceptional service,<br/><em>every step.</em>";
      const parts = h.split(",");
      if (parts.length > 1) return `${parts[0].trim()}<br/><em>${parts.slice(1).join(",").trim()}</em>`;
      return h;
    },
    heroPrimaryText() { return this.loinfo?.right_button_text || "Apply Now"; },
    heroSecondaryText() { return this.loinfo?.left_button_text || "Schedule Appointment"; },
    heroBody() {
      const m = (this.realtor?.main || this.loinfo?.main || "").trim();
      if (m) return m;
      return [this.loinfo?.text_section_body_p1, this.loinfo?.text_section_body_p2].filter(Boolean).join(" ").trim()
        || this.loinfo?.footer_slogan || "Start your application in minutes and we'll guide you from application through closing.";
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=EB+Garamond:ital,wght@0,400;0,500;1,400&family=Raleway:wght@300;400;500;600&display=swap');

.page {
  min-height: 100vh;
  background: #f8f5f0;
  color: #1a1210;
  font-family: 'Raleway', sans-serif;
  --p: #0b1726;
  --a: #c69c39;
  --crimson: #6b1a1a;
  --bg: #f8f5f0;
  --card-bg: #ffffff;
  --border: rgba(26,18,16,0.1);
  --muted: #7a6e68;
}
.root { display: flex; flex-direction: column; min-height: 100vh; }

/* TOP STRIP */
.cs-topstrip { background: var(--crimson); display: flex; align-items: center; justify-content: center; gap: 12px; padding: 7px 0; }
.ts-text { font-family: 'Cinzel', serif; font-size: 9px; letter-spacing: 0.25em; color: rgba(255,255,255,0.55); }
.ts-dot { color: var(--a); font-size: 7px; }

/* NAV */
.cs-nav { display: flex; align-items: center; justify-content: space-between; padding: 20px 60px; border-bottom: 1px solid var(--border); background: #fff; }
.cs-logo { width: 150px; max-height:76px; object-fit: contain; }
.cs-cta { font-family: 'Cinzel', serif; font-size: 10px; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase; text-decoration: none; background: var(--crimson); color: #f8f5f0; padding: 11px 24px; border-radius: 4px; transition: opacity 0.2s; }
.cs-cta:hover { opacity: 0.88; }

/* HERO */
.cs-hero { background: var(--p); position: relative; overflow: hidden; padding: 72px 60px; }
.hero-arch { position: absolute; bottom: -120px; right: -80px; width: 400px; height: 400px; border-radius: 50%; border: 60px solid color-mix(in srgb, var(--a) 8%, transparent); }
.cs-hero-content { position: relative; z-index: 1; max-width: 680px; margin: 0 auto; text-align: center; }
.ch-tag { display: flex; align-items: center; justify-content: center; gap: 16px; margin-bottom: 28px; font-family: 'Cinzel', serif; font-size: 9px; letter-spacing: 0.22em; color: var(--a); opacity: 0.8; }
.tag-rule { width: 40px; height: 1px; background: var(--a); opacity: 0.4; }
.cs-h1 { font-family: 'EB Garamond', serif; font-size: clamp(38px, 5.5vw, 68px); font-weight: 500; line-height: 1.1; color: #f5f0e8; margin: 0 0 22px; }
.cs-h1 em { font-style: italic; color: var(--a); }
.cs-body { font-size: 15px; line-height: 1.8; color: rgba(245,240,232,0.55); margin-bottom: 36px; font-weight: 300; }
.cs-btns { display: flex; align-items: center; justify-content: center; gap: 14px; flex-wrap: wrap;; }
.cs-btn-gold {width:55%; font-family: 'Cinzel', serif; font-size: 10px; font-weight: 600; letter-spacing: 0.14em; text-decoration: none; background: var(--a); color: var(--p); padding: 14px 36px; border-radius: 4px; transition: opacity 0.2s; }
.cs-btn-gold:hover { opacity: 0.88; }
.cs-btn-ghost { font-size: 13px; text-decoration: none; color: rgba(245,240,232,0.5); border: 1px solid rgba(255,255,255,0.15); padding: 13px 28px; border-radius: 4px; transition: border-color 0.18s; }
.cs-btn-ghost:hover { border-color: rgba(255,255,255,0.35); }

/* AGENTS */
.cs-agents { background: var(--bg); padding: 52px 60px; }
.cs-agents-inner { max-width: 900px; margin: 0 auto; display: flex; gap: 0; align-items: stretch; }
.cs-card { flex: 1; background: var(--card-bg); border: 1px solid var(--border); border-radius: 10px; overflow: hidden; padding: 28px; }
.cc-top { display: flex; gap: 16px; align-items: flex-start; margin-bottom: 16px; padding-bottom: 16px; border-bottom: 2px solid; }
.lo-cc-top { border-color: color-mix(in srgb, var(--p) 12%, transparent); }
.re-cc-top { border-color: color-mix(in srgb, var(--a) 20%, transparent); }
.cc-img { width: 60px; height: 60px; border-radius: 8px; object-fit: cover; flex-shrink: 0; }
.cc-tag { font-family: 'Cinzel', serif; font-size: 8px; letter-spacing: 0.2em; color: var(--muted); display: block; margin-bottom: 4px; text-transform: uppercase; }
.re-cc-tag { color: color-mix(in srgb, var(--a) 70%, #1a1210); }
.cc-name { font-family: 'EB Garamond', serif; font-size: 20px; font-weight: 500; color: var(--p); line-height: 1.2; }
.cc-role { font-size: 11px; color: var(--muted); margin-top: 2px; }
.cc-nmls { font-size: 10px; color: color-mix(in srgb, var(--muted) 65%, transparent); margin-top: 2px; }
.cc-mid { display: none; }
.cc-contacts { display: flex; flex-direction: column; gap: 5px; margin-bottom: 16px; }
.cc-link { font-size: 11px; text-decoration: none; transition: color 0.18s; color: var(--muted); }
.lo-cc-link:hover { color: var(--crimson); }
.re-cc-link:hover { color: color-mix(in srgb, var(--a) 80%, #1a1210); }
.cc-cta { display: block; text-align: center; text-decoration: none; font-family: 'Cinzel', serif; font-size: 10px; letter-spacing: 0.1em; padding: 11px; border-radius: 6px; transition: opacity 0.2s; }
.lo-cc-cta { background: var(--crimson); color: #f8f5f0; }
.lo-cc-cta:hover { opacity: 0.88; }
.cs-divider { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 0 24px; gap: 10px; }
.cd-line { width: 1px; flex: 1; background: var(--border); }
.cd-icon { color: var(--a); font-size: 10px; opacity: 0.5; }

@media (max-width: 820px) {
  .cs-nav { padding: 16px 24px; }
  .cs-hero { padding: 52px 24px; }
  .cs-agents { padding: 36px 24px; }
  .cs-agents-inner { flex-direction: column; gap: 16px; }
  .cs-divider { flex-direction: row; padding: 4px 0; }
  .cd-line { height: 1px; width: 100%; flex: 1; }
}
</style>
